import React from "react";
import { Divider, Button } from "@material-ui/core";
import { GetChartByName } from "./Charts";

import { hashHistory } from "browserHistory";
import styled from "styled-components";

const ConclusionGroup = styled.div`
  page-break-inside: avoid;
  margin-top: 20px;

  @media print {
    padding-top: 60px;
  }
`;

const Header = styled.div`
  font-size: 18px;
`;

const UpdgradeSection = styled.div`
  margin: 20px;
`;

const UpdgradeText = styled.div`
  color: #5d5d5d;
  margin-bottom: 20px;
`;

const SampleHeading = styled.div`
  color: #3e51b5;
  margin: 20px;
  font-size: 24px;
  text-align: center;
`;

const headersWithCharts = [
  {
    name: "Your Benchmark Return & Benchmark Fees",
    charts: ["comparativePortfolioAndBenchmarkReturns"],
    headerAfter: true,
  },
  {
    name: "General",
    charts: [
      "portfolioValuesPer100ChartData",
      "benchmarkValuesPer100ChartData",
    ],
  },
  {
    name: "Portfolio Risk versus Return Effects",
    charts: [
      "comparativeAverageReturn",
      "comparativePortfolioAndBenchmarkRisks",
    ],
  },
  {
    name: "Change Managers?",
    charts: ["maximumRecommendedManagerFees"],
  },
  {
    name: "Portfolio Exposure to Economic Factors and Beta Risk",
    charts: ["portfoliosSensitivityToFactorsAfterFees"],
  },
];

function getConclusionItem(header, items, isExcluded, props) {
  const { portfolio, shoppingCartActions, isPreview } = props;

  if (isExcluded) {
    return (
      <ConclusionGroup>
        {<Header>{header}</Header>}
        <UpdgradeSection>
          {isPreview && (
            <UpdgradeText>
              This section will be included when you check out.
            </UpdgradeText>
          )}
        </UpdgradeSection>
        <Divider />
      </ConclusionGroup>
    );
  }

  var headerItem = headersWithCharts.find((e) => e.name === header);

  return (
    <ConclusionGroup>
      {!headerItem && <Header>{header}</Header>}
      {headerItem && (
        <div>
          {!headerItem.headerAfter && <Header>{header}</Header>}
          <div style={{ display: "flex", flexWrap: "wrap" }}>
            {headerItem.charts.map((e, i) => (
              <div key={`chart_${i}`}>{GetChartByName(props, e)}</div>
            ))}
          </div>
          {headerItem.headerAfter && <Header>{header}</Header>}
        </div>
      )}
      <div>
        <ul>
          {items.map((e, i) => (
            <li key={i} style={{ padding: 5 }}>
              {e.heading ? e.heading : ""}
              {e.value ? e.value : e}
              {e.childItems && (
                <div>
                  {e.childItems.map((item, itemIndex) => (
                    <div key={`${i}_${itemIndex}`}>
                      <div style={{ display: "flex", marginTop: 5 }}>
                        <div
                          style={{
                            width: 300,
                            minWidth: 300,
                            fontWeight: "bold",
                            textAlign: "right",
                            marginRight: 10,
                          }}
                        >
                          {item.heading}:
                        </div>
                        <div>
                          {item.value}
                          {item.subValue && (
                            <div
                              style={{
                                marginTop: 5,
                                fontStyle: "italic",
                                color: "#7d7d7d",
                                fontSize: 14,
                              }}
                            >
                              {item.subValue}
                            </div>
                          )}
                        </div>
                      </div>

                      {/* <b>{item.heading ? `${item.heading}: ` : ''}</b>{item.value ? item.value : item} */}
                    </div>
                  ))}
                </div>
              )}
            </li>
          ))}
        </ul>
      </div>
      <Divider />
    </ConclusionGroup>
  );
}

const Conclusions = (props) => {
  const { portfolio, isPreview } = props;
  const { conclusions } = portfolio;

  const { reportItems } = conclusions;

  return (
    <div>
      {isPreview && (
        <div>
          <Divider />
          <SampleHeading>
            This is a Preview RoboPPA™ report for your portfolio
          </SampleHeading>
        </div>
      )}
      <div>
        <div style={{ marginBottom: 20 }}>
          <Divider />
        </div>

        {reportItems.map((e, i) => (
          <div key={`ri_${i}`}>
            {getConclusionItem(e.name, e.details, e.excluded, props)}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Conclusions;



// WEBPACK FOOTER //
// ./src/portfolio/components/Conclusions.js